<div class="component batchPage">
  <div>
    <h3 class="batchTitle">Batch</h3>
  </div>
  <div class="alignleft content mat-elevation-z8 batchPreDataSection">
    <div class="batchFilterSection" style="display:flex">
      <mat-form-field class="batchFilterSection">
        <mat-label>Type keyword to filter results</mat-label>
        <button matPrefix
                mat-icon-button
                color="primary"
                matTooltip="Filter grid data"
                matTooltipPosition="below">
          <mat-icon>search</mat-icon>
        </button>
        <input matInput (keyup)="ApplyFilter($event.target.value)" id="input_filter">
      </mat-form-field>
      <mat-form-field class="batchStatusDropdown">
        <mat-label>Status</mat-label>
        <mat-select (selectionChange)="selectDisplayedBatches()" [(value)]="ssSelectedStatus">
          <mat-option value="complete">Reviewed</mat-option>
          <mat-option value="incomplete">Not Reviewed</mat-option>
          <mat-option value="both">Select All</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="buttonGroupBatchPage">
      <button class="columnButton" color="accent" (click)="showColumnDialog()" mat-raised-button>
        <span class="material-symbols-outlined columnIcon">
          dashboard_customize
        </span>
      </button>
      <button [disabled]="DisplayedBatchData.data.length === 0" (click)="ExportData()" mat-raised-button color="primary" class="first-button"><mat-icon>create</mat-icon> Export</button>
    </div>
  </div>
  <table class="batchTable" mat-table [dataSource]="DisplayedBatchData" matSort matSortActive="batchID" matSortDisableClear matSortDirection="desc">
    <!-- Columns -->
    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>{{getHeaderName('status')}}</th>
      <td mat-cell class="center-cell" *matCellDef="let row">
        <span class="vixientTeal" *ngIf="row.inReviewCount > 0"><mat-icon>timelapse</mat-icon></span>
        <span class="vizientGreen" *ngIf="row.inReviewCount === 0"><mat-icon>check_circle</mat-icon></span>
      </td>
    </ng-container>
    <ng-container matColumnDef="batchID">
      <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>{{getHeaderName('batchId')}}</th>
      <td mat-cell class="center-cell batchHyperlink" *matCellDef="let row"><a (click)="markBatch(row.batchID)" [routerLink]='["/search"]' [queryParams]="{BatchId: row.batchID }" [innerHTML]="row.batchID | highlight: DisplayedBatchData.filter"></a> </td>
    </ng-container>
    <ng-container matColumnDef="fileName">
      <th mat-header-cell class="leftAlignHeader" *matHeaderCellDef mat-sort-header disableClear>{{getHeaderName('fileName')}}</th>
      <td mat-cell *matCellDef="let row" [innerHTML]="row.fileName | highlight: DisplayedBatchData.filter"></td>
    </ng-container>
    <ng-container matColumnDef="submitted_Date">
      <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>{{getHeaderName('submittedDate')}}</th>
      <td mat-cell class="center-cell" *matCellDef="let row" [innerHTML]="row.submitted_Date.toLocaleString() | highlight: DisplayedBatchData.filter"></td>
    </ng-container>
    <ng-container matColumnDef="userEmail">
      <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>{{getHeaderName('UploadedBy')}}</th>
      <td mat-cell class="center-cell" *matCellDef="let row" [innerHTML]="row.userEmail | highlight: DisplayedBatchData.filter"></td>
    </ng-container>
    <ng-container matColumnDef="totalSubmissionCount">
      <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>{{getHeaderName('TotalSubmissionCount')}}</th>
      <td mat-cell class="center-cell" *matCellDef="let row" [innerHTML]="row.totalSubmissionCount | highlight: DisplayedBatchData.filter"></td>
    </ng-container>
    <ng-container matColumnDef="successCount">
      <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>{{getHeaderName('SuccessCount')}}</th>
      <td mat-cell class="center-cell" *matCellDef="let row" [innerHTML]="row.successCount | highlight: DisplayedBatchData.filter"></td>
    </ng-container>
    <ng-container matColumnDef="failureCount">
      <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>{{getHeaderName('FailureCount')}}</th>
      <td mat-cell class="center-cell" *matCellDef="let row" [innerHTML]="row.failureCount | highlight: DisplayedBatchData.filter"></td>
    </ng-container>
    <!-- Header -->
    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
  <div class="messageArea" *ngIf="DisplayedBatchData.data.length === 0">
    <span *ngIf="!Loading && NoData && !Error">No records found</span>
    <span class="errorMessage" *ngIf="Loading"><mat-spinner [diameter]="30"></mat-spinner> Loading...</span>
    <span class="errorMessage" *ngIf="Error">An Error happened during the data load.  If this continues contact support.</span>
  </div>
  <mat-paginator (page)="changePageSize($event.pageSize)" [pageSizeOptions]="[5, 10, 25, 100]" [pageSize]=batchPageSize showFirstLastButtons></mat-paginator>
</div>
